import { AppState } from '../store';

export const selectUser = (store: AppState) => store.user;
